<template>
  <Adminlte>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="box box-primary center-block">
          <div class="box-header with-border">
            <h3 class="box-title">Editar Parque Tecnológico</h3>
          </div>
          <ParkForm :park="park" :errors="errors" :onSubmit="onSubmit"></ParkForm>
        </div>
      </div>
    </div>
    <notifier ref="notifier"></notifier>
  </Adminlte>
</template>
<script>
import Adminlte from '@/components/template/Adminlte'
import ParkClient from '@/services/resource_client/park'
import ParkForm from '@/pages/parks/ParkForm'
import Notifier from '@/components/elements/Notifier'
import Authentication from '@/services/authentication'

export default {
  name: 'EditPark',
  components: { Adminlte, ParkForm, Notifier },
  data: function () {
    return {
      park: {},
      errors: {}
    }
  },
  props: ['id'],
  methods: {
    onSubmit () {
      ParkClient.put(this.park)
      .then(r => {
        this.$refs.notifier.showSavedFormNotification()
        this.errors = {}

        if (Authentication.userHasParkRole()) {
          Authentication.getParkData()
        }
      })
      .catch(e => {
        this.errors = e.response.data.errors
        this.$refs.notifier.showErrorNotification()
      })
    }
  },
  created () {
    ParkClient.get(this.id)
    .then(r => {
      this.park = r.data
    })
  }
}
</script>



// WEBPACK FOOTER //
// EditPark.vue?9fbdea32